module.exports = __webpack_public_path__ + "img/label.a3f02394.jpg";